<template>
    <section
        v-if="activity.images && activity.images.length > 0"
        class="audience-imagery"
    >
        <h2 class="text-center mb-5">{{ title }}</h2>
        <div class="container position-relative">
            <div class="row">
                <div class="col-12">
                    <div
                        ref="slider__controls"
                        class="slider__controls"
                        aria-label="Imagery slider"
                        tabindex="0"
                    >
                        <button
                            class="prev"
                            aria-controls="customize"
                            data-controls="prev"
                            tabindex="-1"
                        >
                            <i
                                class="fa fa-chevron-left color--purple-1"
                                aria-hidden="true"
                            ></i>
                        </button>
                        <button
                            class="next"
                            aria-controls="customize"
                            data-controls="next"
                            tabindex="-1"
                        >
                            <i
                                class="fa fa-chevron-right color--purple-1"
                                aria-hidden="true"
                            ></i>
                        </button>
                    </div>
                    <div ref="slider" class="imagery__slider">
                        <div
                            v-for="(image, index) in activity.images"
                            :key="image.src"
                            class="imagery__slide"
                        >
                            <div
                                :style="
                                    'background-image: url(\'' +
                                        image.src +
                                        '\')'
                                "
                                class="audience-imagery__image"
                            >
                                <copyright
                                    v-if="activity.copyright[index] != null"
                                    :copyright="activity.copyright[index]"
                                ></copyright>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import { tns } from 'tiny-slider/src/tiny-slider';
import copyright from '@/components/blocks/copyright';
export default {
    components: {
        copyright
    },
    props: {
        activity: {
            type: Object,
            default() {
                return {};
            }
        },
        images: {
            type: Array,
            default() {
                return [];
            }
        },
        copyright: {
            type: Array,
            default() {
                return [];
            }
        },
        slides: {
            type: Number,
            default: 5
        },
        title: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            slider: null
        };
    },
    updated() {
        this.$nextTick(() => {
            this.initSlider();
        });
    },
    mounted() {
        this.$nextTick(() => {
            this.initSlider();
        });
    },

    methods: {
        initSlider() {
            if (this.activity.images && this.activity.images.length > 0) {
                this.slider = tns({
                    container: this.$refs.slider,
                    items: 1,
                    controlsContainer: this.$refs.slider__controls,
                    slideBy: 1,
                    mouseDrag: false,
                    swipeAngle: false,
                    lazyload: true,
                    nav: false,
                    autoplayButton: false,
                    autoplayButtonOutput: false,
                    preventScrollOnTouch: 'auto',
                    speed: 400,
                    responsive: {
                        768: {
                            items: 2,
                            gutter: 30
                        },
                        992: {
                            items: 3
                        }
                    }
                });
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.slider__controls {
    position: absolute;
    height: 100%;
    width: 100%;
    display: block;
    left: 0;
}

.prev {
    position: absolute;
    left: 15px;
    font-size: 24px;
    top: 50%;
    transform: translateY(-50%);
    z-index: 20;
    cursor: pointer;
    background: none;
    border: 0;

    @include media-breakpoint-up(md) {
        left: -20px;
        font-size: 30px;
    }

    @include media-breakpoint-up(lg) {
        left: -40px;
    }
}

.next {
    position: absolute;
    right: 15px;
    font-size: 24px;
    top: 50%;
    transform: translateY(-50%);
    z-index: 20;
    cursor: pointer;
    background: none;
    border: 0;

    @include media-breakpoint-up(md) {
        right: -20px;
        font-size: 30px;
    }

    @include media-breakpoint-up(lg) {
        right: -40px;
    }
}
</style>

<style lang="scss">
.audience-imagery__image {
    position: relative;
    border-radius: 7px;
    height: 260px;
    background-size: cover;
    background-position: center center;

    &:hover {
        .copyright {
            background-color: $blue-7;
            color: $white;
        }
        .copyright__text {
            opacity: 1;
        }
    }
}

.copyright {
    position: absolute;
    font-size: 0.675rem;
    padding: 2px 10px;
    left: 0;
    bottom: 0;
    width: 100%;
    background-color: transparent;
    color: $blue-7;
    opacity: 0.9;
    border-radius: 0 0 7px 7px;
    transition: background-color 0.25s ease-in-out, color 0.25s ease-in-out;
}

.copyright__text {
    opacity: 0;
    transition: opacity 0.25s ease-in-out;
}

.imagery__slide {
    padding: 0 35px 30px 35px;

    @include media-breakpoint-up(md) {
        padding: 0;
    }
}
</style>
